import { render, staticRenderFns } from "./omsetjeniskiriman_list.vue?vue&type=template&id=9af0843c"
import script from "./omsetjeniskiriman_list.vue?vue&type=script&lang=js"
export * from "./omsetjeniskiriman_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports